import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import Icon from "../Icon";
import { Input } from "../Inputs";
import Button from "../Button";
import ModalConfirmation from "./ModalConfirmation";
import { useDispatch } from "react-redux";
import { updateUserLimitsRequest } from "../../redux/actions/organizations";
import { useTranslation } from "react-i18next";

export default function ModalUserLimitUpdate(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { loggedInOrganization, selectUser, isOpen, toggle, changeControl } =
    props;
  const [maxBuyAmountLimit, setMinAmountLimit] = useState();
  const [maxSellAmountLimit, setMaxAmountLimit] = useState();
  const [minSellPriceLimit, setMinPriceLimit] = useState();
  const [maxBuyPriceLimit, setMaxPriceLimit] = useState();
  const [userParametersConfirmationModal, setUserParametersConfirmationModal] =
    useState(false);
  const limitsChange = (e) => {
    if (e.target.name === "maxBuyAmountLimit") {
      setMinAmountLimit(e.target.value || null);
    }
    if (e.target.name === "maxSellAmountLimit") {
      setMaxAmountLimit(parseInt(e.target.value) || null);
    }
    if (e.target.name === "minSellPriceLimit") {
      setMinPriceLimit(e.target.value || null);
    }
    if (e.target.name === "maxBuyPriceLimit") {
      setMaxPriceLimit(e.target.value || null);
    }
  };
  useEffect(() => {
    if (selectUser) {
      setMinAmountLimit(selectUser.maxBuyAmountLimit);
      setMaxAmountLimit(selectUser.maxSellAmountLimit);
      setMinPriceLimit(selectUser.minSellPriceLimit);
      setMaxPriceLimit(selectUser.maxBuyPriceLimit);
    }
  }, [selectUser]);

  useEffect(() => {
    if (!isOpen) onClose();
  }, [isOpen]);
  const sendUserParametersConfirmationToggle = () => {
    setUserParametersConfirmationModal(true);
  };
  const onClose = () => {
    setMinAmountLimit("");
    setMaxAmountLimit("");
    setMinPriceLimit("");
    setMaxPriceLimit("");
  };
  const updateLimits = () => {
    if (userParametersConfirmationModal) {
      dispatch(
        updateUserLimitsRequest({
          userId: selectUser.userId,
          maxBuyAmountLimit: parseInt(maxBuyAmountLimit),
          maxSellAmountLimit,
          minSellPriceLimit: parseFloat(minSellPriceLimit),
          maxBuyPriceLimit: parseFloat(maxBuyPriceLimit),
        })
      );
      setMinAmountLimit("");
      setMaxAmountLimit("");
      setMinPriceLimit("");
      setMaxPriceLimit("");
      setUserParametersConfirmationModal(false);
      toggle();
      changeControl(true);
    }
    return true;
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <>
        <div className="km__c--modal-certificate-header">
          <div
            className="km__c--modal-certificate-header-close"
            onClick={toggle}
          >
            <Icon name="x" size="24" onClick={onClose} />
          </div>
        </div>
        <div
          className="km__p--redemption-operations-inputs-container"
          style={{
            backgroundColor: "none",
            boxShadow: "none",
          }}
        >
          <div className="km__p--redemption-operations-input-title mt-3">
            {t("pages.default.userParameters.title")}
          </div>
          <br></br>
          <Input
            name="maxBuyAmountLimit"
            type="number"
            min={1}
            max={selectUser?.checkMaxBuyAmountLimit}
            pattern="[0-9]+([\.,][0-9]+)?"
            maxlength="9"
            placeholder={`${t("pages.default.userParameters.Max")} ${
              selectUser?.checkMaxBuyAmountLimit === null
                ? ""
                : selectUser?.checkMaxBuyAmountLimit
            }`}
            label={t("pages.default.userParameters.maxBuyAmountLimit")}
            value={maxBuyAmountLimit}
            onChange={limitsChange}
          />
          <Input
            name="maxSellAmountLimit"
            type="number"
            min={1}
            max={selectUser?.checkMaxSellAmountLimit}
            pattern="[0-9]+([\.,][0-9]+)?"
            maxlength="9"
            placeholder={`${t("pages.default.userParameters.Max")} ${
              selectUser?.checkMaxSellAmountLimit === null
                ? ""
                : selectUser?.checkMaxSellAmountLimit
            }`}
            label={t("pages.default.userParameters.maxSellAmountLimit")}
            value={maxSellAmountLimit}
            onChange={limitsChange}
          />
          <Input
            name="minSellPriceLimit"
            min={selectUser?.checkMinSellPriceLimit ?? "0"}
            max={selectUser?.checkMaxPriceLimit}
            pattern="[0-9]+([\.,][0-9]+)?"
            placeholder={`${t("pages.default.userParameters.Min")} ${
              selectUser?.checkMinSellPriceLimit === null
                ? ""
                : selectUser?.checkMinSellPriceLimit +
                  " - " +
                  t("pages.default.userParameters.Max") +
                  selectUser?.checkMaxPriceLimit
            }`}
            acceptDecimal
            type="number"
            label={t("pages.default.userParameters.minSellPriceLimit")}
            value={minSellPriceLimit}
            onChange={limitsChange}
          />

          <Input
            name="maxBuyPriceLimit"
            type="number"
            min={selectUser?.checkMinPriceLimit ?? "0"}
            max={selectUser?.checkMaxBuyPriceLimit}
            pattern="[0-9]+([\.,][0-9]+)?"
            placeholder={`${t("pages.default.userParameters.Max")} ${
              selectUser?.checkMaxBuyPriceLimit === null
                ? ""
                : selectUser?.checkMaxBuyPriceLimit +
                  " - " +
                  t("pages.default.userParameters.Min") +
                  selectUser?.checkMinPriceLimit
            }`}
            acceptDecimal
            label={t("pages.default.userParameters.maxBuyPriceLimit")}
            value={maxBuyPriceLimit}
            onChange={limitsChange}
          />
          <div></div>
          <div>
            <Button
              type="primary"
              label={t("ui.default.edit")}
              onClick={sendUserParametersConfirmationToggle}
            />
          </div>
        </div>
        <ModalConfirmation
          isOpen={userParametersConfirmationModal}
          toggle={() =>
            setUserParametersConfirmationModal(!userParametersConfirmationModal)
          }
          header={t("pages.default.userParameters.confirmation.header")}
          body={t("pages.default.userParameters.confirmation.body")}
          approve={updateLimits}
          // loading={requestLoading}
        />
      </>
    </Modal>
  );
}
